import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import UserCreateModal from './UserCreateModal'
import { actions, types } from '../../../store'

const mapStateToProps = state => ({
  status: state.modal.userCreateModal,
  group: state.group,
  division: state.division
})

const mapDispatchToProps = dispatch => bindActionCreators({
  closeModal: () => actions.modal.setModal(types.MODAL_USER_CREATE, false),
  createUser: actions.user.createUser,
  getDivisions: actions.division.getDivisions
}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserCreateModal)



// WEBPACK FOOTER //
// ./src/components/Modals/UserCreateModal/index.js